import React from 'react';

import { Button } from '../../BaseUI';
import marketingModalStyles from '../Layout/styles.module.css';

const StandardOfferModalBody = ({ buttonText, disclosure, offerLink, trackingProps }) => {
  return (
    <div>
      <div className={marketingModalStyles.offerAction}>
        <Button
          href={offerLink}
          trackingProps={{ ...trackingProps, name: 'subscribe' }}
          trackClick
          variant="primary"
          width="full"
        >
          {buttonText}
        </Button>
      </div>
      <div className={marketingModalStyles.disclosure}>{disclosure}</div>
    </div>
  );
};

export default StandardOfferModalBody;
